import SectionHeader from '../../components/SectionHeader/SectionHeader.tsx'

const paths = [
	{
		year: '2015',
		h4: <>Started writing for the web.</>,
		body: "First production code, first deploy, first rollback at 3am. The kind of beginning where you don't yet know how much you don't know.",
		seg: 'SEG 01',
	},
	{
		year: '2018 — 2022',
		h4: (
			<>
				Got{' '}
				<span className="font-serif italic font-medium normal-case">quieter,</span> more useful.
			</>
		),
		body: 'Senior IC. The point where you stop trying to be the smartest person in the room and start trying to make the room smarter.',
		seg: 'SEG 02',
	},
	{
		year: '2022 →',
		h4: (
			<>
				Engineering{' '}
				<span className="font-serif italic font-medium normal-case">manager.</span>
			</>
		),
		body: 'Engineering manager at Nine, publishing division. Editorial tooling, newsroom systems, AI in the workflow, and a small group of very good engineers I get to work for.',
		seg: 'SEG 03',
	},
]

const LeadershipStorySection = () => {
	return (
		<section className="px-6 py-16 border-b-4 border-ink">
			<div className="motion-safe:animate-rise">
				<SectionHeader
					number="02"
					variant="cobalt"
					titlePrimary="From developer to"
					titleSecondary="engineering leader."
					subtitle="The route, told briefly — the balance between technical practice and people leadership."
					metaLines={['SECTION 02', 'WAYPOINTS', '03 STAGES']}
				/>
			</div>

			<div className="max-w-[1400px] border-2 border-ink motion-safe:animate-rise motion-safe:[animation-delay:120ms]">
				{paths.map((path, index) => (
					<div
						key={path.seg}
						className={`grid grid-cols-1 md:grid-cols-[200px_1fr_80px] gap-4 md:gap-8 px-7 py-7 hover:bg-hazard transition-colors duration-150${
							index < paths.length - 1 ? ' border-b-2 border-ink' : ''
						}`}
					>
						<div className="font-display-cond text-[32px] leading-none tracking-[-0.02em] uppercase text-ink self-start">
							{path.year}
						</div>
						<div>
							<h4 className="font-display font-extrabold uppercase text-[28px] leading-[1.1] text-ink mb-3">
								{path.h4}
							</h4>
							<p className="font-serif text-[15px] leading-[1.5] text-ink-2 max-w-[780px]">
								{path.body}
							</p>
						</div>
						<div className="font-mono text-[10px] uppercase text-ink-dim text-right tracking-[0.06em] self-start">
							{path.seg}
						</div>
					</div>
				))}
			</div>
		</section>
	)
}

export default LeadershipStorySection
